// @flow

import _ from 'lodash';

import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { leaveConference } from '../../base/conference/actions';
import { translate } from '../../base/i18n';
import { connect } from '../../base/redux';
import { AbstractHangupButton } from '../../base/toolbox/components';
import type { AbstractButtonProps } from '../../base/toolbox/components';

// CUSTOM
import {
    closeVideoCall,
    setUsersData,
    showHideCustomModal,
    showHideModeratorDisconnect,
    showHideMultiModeratorDisconnect,
    unsetConference,
    setGhostVoiceSync,
    showToastPopup,
} from "../../customise/redux/tool-webjam/actions";
import { sendData } from "../../webjam/websocket";
import { JitsiRecordingConstants } from "../../base/lib-jitsi-meet";
import { getActiveSession } from "../../recording/functions";
import { Constant, CURRENT_ROOM_NAME } from '../../webjam/constant';
import axios from 'axios';
import { socketEmit } from "../../../../socket";
import {
    FEATURE_CUSTOM_REDUX,
    FEATURE_CUSTOM_REDUX_V2,
    FEATURE_CUSTOM_REDUX_V3,
} from "../../customise/constant";
import {
    isLocalParticipantModerator,
    getRemoteParticipants,
    getLocalParticipant,
} from "../../base/participants";
import { StopStemRecApi } from "../../customise/custom/toolbar/recording-streaming";
import {
    getRecordingStreamingType,
    hostHangupNewApi,
    userHangupApi,
} from "../../customise/welcome-dashboard/Request.d";
import {
    dispatch,
    getBaseConfig,
    isSocialMobileApp,
    SaveLog,
    _ValidateIPaddress,
    getStore,
} from "../../customise/Utils";
import { setPrejoinScreenDetail } from "../../customise/redux/tool-webjam-v2/actions";
import { getLJsonStorage } from "../../customise/welcome-dashboard/Utils";
import { setConfirmationModalProps, setUserHangupStatus } from '../../customise/redux/tool-webjam-v3/actions';
import { ct } from '../../customise/constant-Utils';
// END

/**
 * The type of the React {@code Component} props of {@link HangupButton}.
 */
type Props = AbstractButtonProps & {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function
};

/**
 * Component that renders a toolbar button for leaving the current conference.
 *
 * @augments AbstractHangupButton
 */
class HangupButton extends AbstractHangupButton<Props, *> {
    _hangup: Function;

    accessibilityLabel = 'toolbar.accessibilityLabel.hangup';
    label = 'toolbar.hangup';
    tooltip = 'toolbar.hangup';

    /**
     * Initializes a new HangupButton instance.
     *
     * @param {Props} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        this._hangup = _.once(() => {
            sendAnalytics(createToolbarEvent('hangup'));
            // CUSTOM
            const {
                authOrganization,
                tokenDecodedData,
            } = this.props;

            let _this = this;
            setTimeout(() => {
                const { userHangupStatus } = getStore(FEATURE_CUSTOM_REDUX_V3)
                console.log("host hangup flow 18 =>", userHangupStatus)
                if (userHangupStatus == "end" || userHangupStatus == "") {
                    console.log("host hangup flow 19 =>")
                    dispatch(
                        userHangupApi({
                            socketId: localStorage.getItem("socketId"),
                            organization: authOrganization?.name,
                            organization_id: authOrganization?._id,
                        })
                    );
                } else {
                    console.log("host hangup flow 20 =>")
                    socketEmit('user_hangup_api_event', {
                        roomName: CURRENT_ROOM_NAME,
                        userHangupStatus: userHangupStatus,
                        tokenDecodedData: tokenDecodedData
                    });
                }
                // END

                _this.checkRecordingStreaming();
                sendAnalytics({
                    action: "server-disconnect",
                    source: "conference",
                    category: "conference disconnect",
                });

                // FIXME: these should be unified.
                if (navigator.product === "ReactNative") {
                    _this.props.dispatch(appNavigate(undefined));
                } else {
                    console.log("host hangup flow 21 =>")
                    // Remove all localstorage
                    sessionStorage.removeItem("automanagehost");
                    sessionStorage.removeItem("uniqueId");
                    sessionStorage.removeItem("preJoinTimer");
                    localStorage.removeItem("storeDominant");
                    localStorage.removeItem("makeHostConnect");
                    localStorage.removeItem("thirdPartyMakeHostConnect");
                    localStorage.removeItem("newRoomHosted");
                    localStorage.removeItem("autopopup");
                    localStorage.removeItem("makeHost");
                    localStorage.removeItem("autoConnect");
                    localStorage.removeItem("uniqueID");
                    localStorage.removeItem("connectPop");
                    localStorage.removeItem("windowRedirect");
                    localStorage.removeItem("roomFound");
                    sessionStorage.removeItem("dv_cnf_tm");
                    sessionStorage.removeItem("up_time_" + CURRENT_ROOM_NAME);

                    if (isSocialMobileApp()) {
                        window.parent.location.href = getBaseConfig("appReferrerUrl");
                    } else {
                        // social url change code
                        let socialAllowed = getBaseConfig("socialAllowed");
                        if (socialAllowed == true) {
                            setTimeout(() => {
                                window.parent.location.href = getBaseConfig("socialReferrerUrl") + "/OuIVuX07";
                            }, 2000);
                        }
                    }
                    // END
                    _this.props.dispatch(leaveConference());
                    // CUSTOM
                }
            }, 1000)
            // END
        });
    }

    // CUSTOM
    componentDidUpdate(prevProps) {
        const { closeVideo, dispatch, endRoomData, doHangUpRec } = this.props;
        if (prevProps.closeVideo !== closeVideo) {
            if (closeVideo) {
                dispatch(closeVideoCall({ closeVideo: false }));
                this.handleDisconnect();
            }
        }
        if (prevProps.endRoomData !== endRoomData) {
            if (endRoomData) {
                dispatch(setUsersData(null));
            }
        }

        if (prevProps.doHangUpRec !== doHangUpRec) {
            if (doHangUpRec) {
                dispatch(setUsersData(null));
                this._hangup();
            }
        }
    }

    async checkRecordingStreaming() {
        const {
            _session,
            usersData,
            recTimeStamp,
            recIpAddress,
            uniqueId,
            _isLiveStreamRunning,
            _isRecordingRunning,
            _fileRecordingSession,
            roomorIpAddress,
            moderatorCount,
            devicesUsers,
            stemRecording,
            getLocalParticipant,
            authOrganization,
        } = this.props;

        // Check if room has more than 1 moderator of jitsi
        // also check if stem recording is in progress
        if (moderatorCount > 0) {
            if (devicesUsers || usersData) {
                if (stemRecording) {
                    if (devicesUsers?.uniqueId == usersData?.uniqueId) {
                        socketEmit("device_user", {
                            roomName: roomorIpAddress,
                            location: window.location.origin,
                            isLeft: true,
                            jitsiId: getLocalParticipant.id,
                        });
                        StopStemRecApi();
                    }
                }
                return false;
            }
        }

        let isJibriRecording = false;
        let recordingTypeRes = await getRecordingStreamingType(
            "?organization_id=" + authOrganization?._id
        );

        if (recordingTypeRes.data.status) {
            isJibriRecording = recordingTypeRes.data.data.recording_type == "JIBRI";
        }

        if (_isRecordingRunning) {
            if (usersData) {
                if (isJibriRecording == false) {
                    let url = Constant.App.ServerUrl + "/stop-audio-route?roomname=" + roomorIpAddress + "&processtype=recording";
                    axios
                        .get(url)
                        .then((response) => {
                            console.log(" STOP RECORD ON HANGUP:::::::::::: ", response);
                            if (response.data.status) {
                                if (usersData) {
                                    socketEmit("stop_recording", {
                                        recordingip: recIpAddress,
                                        recordingkey: recTimeStamp,
                                        recordingUniqueID: uniqueId,
                                    });
                                }
                            } else {
                                console.log("ERROR STOP Recording :", error);
                            }
                        })
                        .catch((error) => {
                            console.log("Invalid STOP streaming :", error);
                        });
                }
            }

            if (_fileRecordingSession) {
                this.props._conference.stopRecording(_fileRecordingSession.id);

                if (isJibriRecording) {
                    setTimeout(() => {
                        let fileName = `${recIpAddress}_${recTimeStamp}.mp4`;
                        const url =
                            Constant.App.JibriRecordingUrl +
                            "/" +
                            authOrganization.name +
                            "/recordings/" +
                            fileName;
                        let element = document.createElement("a");
                        element.setAttribute("href", url);
                        element.setAttribute("download", fileName);
                        element.setAttribute("target", "_blank");
                        element.click();
                    }, 1000);
                }
            }
        } else if (_isLiveStreamRunning) {
            if (isJibriRecording == false) {
                if (usersData) {
                    let url = Constant.App.ServerUrl + "/stop-audio-route?roomname=" + roomorIpAddress + "&processtype=recording";
                    axios
                        .get(url)
                        .then((response) => {
                            console.log(" STOP :::::::::::: ", response);
                        })
                        .catch((error) => {
                            console.log("Invalid STOP streaming :", error);
                        });
                }
            }

            if (_session) {
                this.props._conference.stopRecording(_session.id);
            }
        }
    }

    // Handle Disconnect Socket:-
    handleDisconnect() {
        const { dispatch, uniqueId, room } = this.props;
        var message = {
            action: {
                ipAddress: room,
                uniqueID: uniqueId,
            },
            content: "server-disconnect",
            isBroadcast: true,
            sender: "mobile",
        };

        //-------------Prepare logger data -------------
        var log_data = {
            functionName: "",
            triggeredBy: "system",
            event: message.content,
            requestData: message,
            responseData: "",
            userId: "",
            boxId: message.action.uniqueID,
            message: "Emit to server",
        };
        SaveLog(log_data);
        //-------------------------------------------

        sendData(message);
        dispatch(showHideCustomModal({ showModalError: false }));
        dispatch(setUsersData(null));

        dispatch(setPrejoinScreenDetail({
            isSet: true,
            roomname: CURRENT_ROOM_NAME,
            uniqueId: "",
            scope: "hangup"
        }))

        setTimeout(function () {
            dispatch(setPrejoinScreenDetail({
                isSet: false,
                roomname: "",
                uniqueId: "",
                scope: "hangup timeout"
            }))
        }, 10000)
        this._hangup();
    }

    // To confirm if user wants to leave or not
    userHangupConfirmation() {
        console.log("host hangup flow 13 =>")
        dispatch(setConfirmationModalProps({
            isShow: true,
            title: ct("Translate.typography.confirmation"),
            content: ct("Translate.messages.hangUpConfirmation"),
            successBtnName: ct("Translate.buttonTitle.yesSmall"),
            cancelBtnName: ct("Translate.buttonTitle.noSmall"),
            onSuccess: () => {
                this._hangup();
                dispatch(setConfirmationModalProps({ isShow: false }));
            },
            onCancel: () => {
                dispatch(setConfirmationModalProps({ isShow: false }));
            }
        }));
    }

    // To confirm if host wants to leave or not
    hostHangupConfirmation(hitHostHangupApi) {
        console.log("host hangup flow 14 =>", hitHostHangupApi)
        const {
            userLoginData,
            usersData,
            roomorIpAddress,
            uniqueId
        } = this.props;
        dispatch(setConfirmationModalProps({
            isShow: true,
            title: ct("Translate.typography.confirmation"),
            content: userLoginData?.isAdmin && !usersData?.isHost ? ct("messages.confirmDisconnectRoomOwner", "messages") : ct("messages.confirmDisconnectRoom", "messages"),
            successBtnName: ct("Translate.buttonTitle.yesSmall"),
            cancelBtnName: ct("Translate.buttonTitle.noSmall"),
            onSuccess: () => {
                if (hitHostHangupApi) {
                    console.log("host hangup flow 15 =>")
                    hostHangupNewApi({
                        room: roomorIpAddress,
                        location: window.location.origin,
                        uniqueID: uniqueId,
                        visibleRoom: CURRENT_ROOM_NAME,
                        actionType: 2 // 1 -> boxDisconnected, 2 -> roomDisconnected
                    });
                } else {
                    console.log("host hangup flow 16 =>")
                    dispatch(setUserHangupStatus("allLeaveRoom"))
                }
                this._hangup();
                dispatch(setConfirmationModalProps({ isShow: false }));
            },
            onCancel: () => {
                dispatch(setConfirmationModalProps({ isShow: false }));
            }
        }));
    }

    // To open stop recording / live streaming modals
    recordingStreamingModals() {
        const {
            dispatch,
            moderatorCount,
            _isLiveStreamRunning,
            _isRecordingRunning,
        } = this.props;

        if (_isRecordingRunning) {
            if (moderatorCount == 0) {
                dispatch(
                    showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.recRestrictions.hangupModeratorMsg"),
                        toastSubmitFunction: "continueRecording",
                        toastCancelFunction: "stopRecording",
                    })
                );
            } else if (moderatorCount > 0) {
                dispatch(
                    showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.recRestrictions.hangupModeratorMsg"),
                        toastLeaveFunction: "leaveStopRecording",
                    })
                );
            }
        }

        if (_isLiveStreamRunning) {
            if (moderatorCount == 0) {
                dispatch(
                    showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.streamRestrictions.hangupModeratorMsg"),
                        toastSubmitFunction: "continueStreaming",
                        toastCancelFunction: "stopStreaming",
                    })
                );
            } else if (moderatorCount > 0) {
                dispatch(
                    showToastPopup({
                        toastModal: true,
                        modalText: ct("Translate.streamRestrictions.hangupModeratorMsg"),
                        toastLeaveFunction: "leaveStopStreaming",
                    })
                );
            }
        }
    }
    // END

    /**
     * Helper function to perform the actual hangup action.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _doHangup() {
        // CUSTOM
        const {
            dispatch,
            isFromWebJam,
            isModerator,
            moderatorCount,
            remoteCount,
            userLoginData,
            tokenDecodedData,
            _isLiveStreamRunning,
            _isRecordingRunning,
            usersData,
            authRoomUsers,
            getLocalParticipant,
            roomorIpAddress
        } = this.props;

        const { isRoomClaimed } = userLoginData;
        const isGuestAccount = getLJsonStorage("auth", "guest_id");

        // UPDATE REDUCER FOR GHOST VOICESYNC:
        dispatch(setGhostVoiceSync(false));

        const data = {
            conferenceLeft: true,
        };
        dispatch(unsetConference(data));

        if (isGuestAccount) {
            window.parent.location.href = Constant.App.socialUrl;
            return false;
        }

        // Box connected cases
        if (isFromWebJam || tokenDecodedData) {
            // START: For DUET
            let showMessage = false;
            if (tokenDecodedData) {
                if (authRoomUsers.length) {
                    for (let i = 0; i < authRoomUsers.length; i++) {
                        if (authRoomUsers[i].jitsiUserId == getLocalParticipant.id) {
                            if (
                                authRoomUsers[i].isRoomStarter == true &&
                                tokenDecodedData.teacher == true
                            ) {
                                showMessage = true;
                                break;
                            }
                        }
                    }
                }
            }
            // END: For DUET

            if (_isRecordingRunning || _isLiveStreamRunning) {
                this.recordingStreamingModals();
            } else {
                if (showMessage == true) {
                    dispatch(showHideCustomModal({ showModalError: true }));
                } else {
                    // START: Host Hangup New API hit cases
                    let urlSelfHostRoom = !_ValidateIPaddress(CURRENT_ROOM_NAME)
                    let boxSelfHostRoom = !_ValidateIPaddress(roomorIpAddress);
                    let claimedRoom = userLoginData.isRoomClaimed
                    let roomOwner = userLoginData.isAdmin
                    let hostUser = usersData?.isHost

                    if (getBaseConfig("hostHangupNew") && urlSelfHostRoom) {
                        let hitHostHangupApi = false;
                        console.log("host hangup flow 1 =>", boxSelfHostRoom, hitHostHangupApi)
                        if (boxSelfHostRoom) {
                            console.log("host hangup flow 2 =>", userLoginData)
                            if (userLoginData) {
                                console.log("host hangup flow 3 =>", claimedRoom, roomOwner, hostUser)
                                if (claimedRoom) {
                                    console.log("host hangup flow 4 =>", roomOwner, hostUser, isModerator)
                                    if ((!roomOwner && hostUser) || (!roomOwner && hostUser && isModerator)) {
                                        console.log("host hangup flow 5 =>")
                                        hitHostHangupApi = true;
                                    } else if (!roomOwner && !hostUser) {
                                        console.log("host hangup flow 5.1 =>")
                                        this.userHangupConfirmation();
                                        return false;
                                    }
                                } else {
                                    console.log("host hangup flow 6 =>", hostUser)
                                    if (hostUser) {
                                        console.log("host hangup flow 7 =>", roomOwner, isModerator)
                                        if (!roomOwner || isModerator) {
                                            console.log("host hangup flow 8 =>")
                                            hitHostHangupApi = true;
                                        }
                                    } else {
                                        console.log("host hangup flow 9 =>")
                                        this.userHangupConfirmation();
                                        return false;
                                    }
                                }
                            }
                        }

                        if (hitHostHangupApi) {
                            console.log("host hangup flow 10 =>")
                            this.hostHangupConfirmation(true);
                        } else {
                            console.log("host hangup flow 11 =>")
                            if (!boxSelfHostRoom) {
                                console.log("host hangup flow 11.1 =>")
                                if (claimedRoom) {
                                    console.log("host hangup flow 11.2 =>")
                                    if (roomOwner) {
                                        console.log("host hangup flow 11.3 =>")
                                        this.hostHangupConfirmation(false);
                                        return false;
                                    } else {
                                        console.log("host hangup flow 11.4 =>")
                                        this.userHangupConfirmation();
                                        return false;
                                    }
                                } else {
                                    console.log("host hangup flow 11.5 =>")
                                    this.userHangupConfirmation();
                                    return false;
                                }
                            } else {
                                console.log("host hangup flow 11.6 =>")
                                this.hostHangupConfirmation(false);
                                return false;
                            }
                        }
                    } else {
                        console.log("host hangup flow 12 =>")
                        this.userHangupConfirmation();
                    }
                    // END: Host Hangup New API hit cases
                }
            }
        } else {
            // Box not connected cases
            if (isRoomClaimed && isModerator) {
                if (_isRecordingRunning || _isLiveStreamRunning) {
                    this.recordingStreamingModals();
                } else {
                    if (remoteCount != 0) {
                        if (moderatorCount == 0) {
                            dispatch(showHideModeratorDisconnect({ showModeratorModal: true }));
                        }

                        if (moderatorCount != 0) {
                            dispatch(showHideMultiModeratorDisconnect({ showMultiModeratorModal: true }));
                        }
                    } else {
                        this.userHangupConfirmation();
                    }
                }
            } else {
                this.userHangupConfirmation();
            }
        }
    }
    // END
}

// CUSTOM
// export default translate(connect()(HangupButton));
function _mapStateToProps(state) {
    let moderatorArray = [];
    const isModerator = isLocalParticipantModerator(state);
    const remoteParticipants = getRemoteParticipants(state);
    const remoteArray = _.flatten(Array.from(remoteParticipants));

    if (remoteArray.length > 0) {
        _.filter(remoteArray, function (item) {
            if (item.role === "moderator") {
                moderatorArray.push(item);
            }

            return moderatorArray;
        });
    }

    return {
        endRoomData: state[FEATURE_CUSTOM_REDUX].endRoomData,
        showModalError: state[FEATURE_CUSTOM_REDUX].showModalError,
        showModeratorModal: state[FEATURE_CUSTOM_REDUX].showModeratorModal,
        showMultiModeratorModal:
            state[FEATURE_CUSTOM_REDUX].showMultiModeratorModal,
        errorMessage: state[FEATURE_CUSTOM_REDUX].errorMessage,
        hostData: state[FEATURE_CUSTOM_REDUX].hostData,
        closeVideo: state[FEATURE_CUSTOM_REDUX].closeVideo,
        isFromWebJam: state[FEATURE_CUSTOM_REDUX].isFromWebJam,
        uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
        room: state[FEATURE_CUSTOM_REDUX].room,
        _conference: state["features/base/conference"].conference,
        _fileRecordingSession: getActiveSession(
            state,
            JitsiRecordingConstants.mode.FILE
        ),
        _session: getActiveSession(state, JitsiRecordingConstants.mode.STREAM),
        _isLiveStreamRunning: Boolean(
            getActiveSession(state, JitsiRecordingConstants.mode.STREAM)
        ),
        _isRecordingRunning: Boolean(
            getActiveSession(state, JitsiRecordingConstants.mode.FILE)
        ),
        recIpAddress: state[FEATURE_CUSTOM_REDUX].recIpAddress,
        recTimeStamp: state[FEATURE_CUSTOM_REDUX].recTimeStamp,
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        isModerator: isModerator,
        remoteCount: remoteArray.length,
        moderatorCount: moderatorArray.length,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        devicesUsers: state[FEATURE_CUSTOM_REDUX].devicesUsers,
        stemRecording: state[FEATURE_CUSTOM_REDUX].stemRecording,
        getLocalParticipant: getLocalParticipant(state),
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        authRoomUsers: state[FEATURE_CUSTOM_REDUX].authRoomUsers,
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        doHangUpRec: state[FEATURE_CUSTOM_REDUX_V2].doHangUpRec,
        userHangupStatus: state[FEATURE_CUSTOM_REDUX_V3].userHangupStatus,
    };
}

export default translate(connect(_mapStateToProps)(HangupButton));
// END

